const pink1 = '#f1a9a0';
const pink2 = '#d24d57';
const pink3 = '#d2527f';
const pink4 = '#db0a5b';
const pink5 = '#f62459';
const brown1 = '#96281b';
const purple1 = '#736598';
const purple2 = '#9f5afd';
const purple3 = '#a537fd';
const purple4 = '#bf55ec';
const purple5 = '#d5b8ff';
const purple6 = '#9a12b3';
const purple7 = '#913d88';
const purple8 = '#674172';
const blue1 = '#81cfe0';
const blue2 = '#00b5cc';
const blue3 = '#52b3d9';
const blue4 = '#336e7b';
const blue5 = '#013243';
const blue6 = '#24252a';
const blue7 = '#89c4f4';
const blue8 = '#19b5fe';
const blue9 = '#2c82c9';
const blue10 = '#1f3a93';
const blue11 = '#67809f';
const green1 = '#2ecc71';
const green2 = '#86e2d5';
const green3 = '#29f1c3';
const green4 = '#1E824D';
const green5 = '#00e640';
const green6 = '#90c695';
const green7 = '#91B498';
const yellow1 = '#ffff7e';
const yellow2 = '#f5e51b';
const yellow3 = '#f0ff00';
const yellow4 = '#f7ca18';
const orange1 = '#f15a22';
const orange2 = '#d91e18';
const orange3 = '#f5ab35';
const orange4 = '#e67e22';
const orange5 = '#d35400';
const orange6 = '#f2784b';
const black1 = '#2e3131';
const grey1 = '#f2f1ef';
const grey2 = '#bdc3c7';

export const colors = [
  pink1,
  pink2,
  pink3,
  pink4,
  pink5,
  brown1,
  purple1,
  purple2,
  purple3,
  purple4,
  purple5,
  purple6,
  purple7,
  purple8,
  blue1,
  blue2,
  blue3,
  blue4,
  blue5,
  blue6,
  blue7,
  blue8,
  blue9,
  blue10,
  blue11,
  green1,
  green2,
  green3,
  green4,
  green5,
  green6,
  green7,
  yellow1,
  yellow2,
  yellow3,
  yellow4,
  orange1,
  orange2,
  orange3,
  orange4,
  orange5,
  orange6,
  black1,
  grey1,
  grey2,
];

export const defaultUserColor = blue9;
export const unassignedTaskColor = grey2;

export const chartColors = [
  blue1,
  purple1,
  green1,
  blue2,
  purple2,
  green2,
  blue3,
  purple3,
  green3,
  blue4,
  purple4,
  green4
];

export default {
  colors,
  defaultUserColor,
  unassignedTaskColor,
  chartColors
};
